<template>
    <div class="py-[30px] w-full flex justify-center bg-white shadow-footer">
        <div class="flex space-between align-center">
            <p class="text-main text-[16px] weight-400 font-[montserrat, Roboto]">
                Copyright &copy; {{ new Date().getFullYear() }} NORD HT
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterComponent'
}
</script>